import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"mt-4"},[_c(VCol,{staticClass:"error-banner",attrs:{"cols":"10","offset":"1"}},[_c('span',{staticClass:"red--text"},[_vm._v("Une erreur est survenue.")]),_c('br'),_c('router-link',{attrs:{"to":"/dossier"}},[_vm._v("Retour à la liste des dossiers")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }